import { AxiosResponse } from 'axios';
import { useMutation, useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import { CopyOptionRecipeResponse, DeleteOptionRecipeResponse, EditOptionRequestBody, Option } from './option.types';
import { Subrecipe } from "../subrecipe/subrecipe.types";

export const useOptions = (enabled: boolean = false, requestBody?: { classNo?: string; statusNo?: string }) => {
  return useQuery<AxiosResponse<Option[]>>({
    queryKey: ['options', requestBody?.statusNo, requestBody?.classNo],
    queryFn: () => apiClient.get<Option[]>('/options', { params: requestBody }),
    enabled,
  });
};

export const useOption = (requestBody: { optionNo: string; classNo: string }, enabled: boolean = false) => {
  return useQuery<AxiosResponse<Option>>({
    queryKey: ['options', requestBody.classNo, requestBody.optionNo],
    queryFn: () => apiClient.get<Option>(`/options/${requestBody.optionNo}`, { params: requestBody }),
    enabled,
  });
};

export const useEditOption = (optionNo: string) => {
  return useMutation((requestBody: EditOptionRequestBody) => {
    return apiClient.put(`/options/${optionNo}`, requestBody);
  });
};

export const useGetSubRecipeOptions = (
  requestBody: { classNo: string; baseNo?: string; sizeNo?: string; productNo?: string },
  enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Option[]>>({
    queryKey: [
      'getSubRecipeOptions',
      requestBody.classNo,
      requestBody.baseNo,
      requestBody.sizeNo,
      requestBody.productNo
    ],
    queryFn: () => apiClient.get<Option[]>('/sub-recipes/options', { params: requestBody }),
    enabled
  });
};

export const useCopyOptionRecipes = () => {
  return useMutation<AxiosResponse<CopyOptionRecipeResponse[]>, unknown, number[]>(
    (body: number[]) => {
      return apiClient.post<CopyOptionRecipeResponse[]>(`/sub-recipes`, body);
    }
  );
};

export const useDeleteOptionRecipes = () => {
  return useMutation<AxiosResponse<DeleteOptionRecipeResponse[]>, unknown, Subrecipe[]>(
      (optionRecipes: Subrecipe[]) => {
        return apiClient.post<DeleteOptionRecipeResponse[]>(`/sub-recipes/delete`, optionRecipes)
      }
  )
}